export default "__VITE_ASSET__D1nW8TmV__"